import { render, staticRenderFns } from "./OnSiteMessageStripEdit.vue?vue&type=template&id=e797835a&"
import script from "./OnSiteMessageStripEdit.vue?vue&type=script&lang=js&"
export * from "./OnSiteMessageStripEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports